export const paymentSuccessRoute = () => `/booking/success`
